export default __webpack_public_path__ + "static/media/crmMobile.19b6595e.jpg";